import React from 'react';
import { Container, Stack } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { EventCoverImage } from './EventCoverImage';
import { EventRightBox, IEventSuggestion } from './EventRightBox';
import { EventDescription } from './EventDescription';
import { EventDetails } from './EventDetails';
import { EventHighlight } from './EventHighlight';
import { EventFAQ } from './EventFAQ';
import { EventRequirements } from './EventRequirements';
import { EventHost } from './EventHost';

export interface IEventWrapper extends IEventSuggestion {}

const EventWrapper: React.FC<IEventWrapper> = ({ ...props }) => {
    const { device } = useThemeContext();

    return (
        <Container
            disableGutters={device.isMobile}
            sx={{
                height: {
                    xs: '100dvh',
                    sm: '100%',
                },
            }}>
            <Stack
                gap={2}
                width={'100%'}
                direction={{
                    xs: 'column',
                    sm: 'row',
                }}
                alignItems={{
                    xs: 'flex-start',
                }}>
                <Stack width={'100%'}>
                    <Stack
                        gap={2}
                        direction={{
                            xs: 'column',
                            sm: 'row',
                        }}
                        alignItems={{
                            xs: 'flex-start',
                        }}>
                        <EventCoverImage {...props} />
                    </Stack>
                    <EventHighlight {...props} />
                    <EventDescription {...props} />
                    <EventDetails {...props} />
                    <EventRequirements {...props} />
                    <EventHost {...props} />
                    <EventFAQ {...props} />
                </Stack>
                {device.isDesktop && <EventRightBox {...props} />}
            </Stack>
            {device.isTablet && !device.isMobile && <EventRightBox disableSuggestion {...props} />}
            {device.isMobile && (
                <Stack
                    sx={{
                        position: 'fixed',
                        bottom: -20,
                        left: 0,
                        width: '100%',
                        zIndex: 10, // Ensure it's above other content
                    }}>
                    <EventRightBox {...props} disableSuggestion />
                </Stack>
            )}
        </Container>
    );
};

export { EventWrapper };
